<template>
<header class="layout-header">
  <section class="layout-header-inner">
    <section class="layout-title">环境空气自动监测系统现场质控检查平台</section>
    <section class="user-info">{{profile.realName}}</section>
<!--    <section class="menu">-->
<!--      <section class="menu-icon"></section>-->
<!--    </section>-->
    <section class="header-right">
      <a class="logout-btn" @click="onLogoutBtnClick">退出系统</a>
    </section>
  </section>
</header>
</template>

<script>
export default {
  name: 'LayoutHeader',
  props: {
    profile: {
      required: true,
      type: Object
    }
  },
  methods: {
    onLogoutBtnClick () {
      this.$api.Profile.logout().then(() => {}).catch(console.error).finally(() => {
        this.$store.commit('Profile/removeToken')
      })
    }
  }
}
</script>

<style lang="scss" scoped>
$HEADER-HEIGHT: 40px;

.layout-header {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  padding: 0 20px 0;
  color: #FFF;
  background-color: #349efb;
  z-index: 9;

  .layout-header-inner {
    position: relative;
    width: 100%;
    height: $HEADER-HEIGHT;
  }

  .layout-title {
    position: absolute;
    font-size: 16px;
    left: 0;
    right: 0;
    width: 100%;
    height: 100%;
    line-height: $HEADER-HEIGHT;
    text-align: center;
  }

  .user-info {
    position: relative;
    float: left;
    height: 100%;
    padding-left: 42px;
    line-height: $HEADER-HEIGHT;
    background: {
      image: url("./../../assets/imgs/icouser.png");
      position: 0 center;
      size: 32px;
      repeat: no-repeat;
    }
  }

  .header-right {
    position: relative;
    float: right;
    line-height: $HEADER-HEIGHT;
  }

  .logout-btn {
    text-decoration: underline;
    cursor: pointer;
  }

  /*.menu {*/
  /*  position: relative;*/
  /*  float: right;*/
  /*  width: 26px;*/
  /*  height: 100%;*/
  /*  padding: 10px 0;*/

  /*  .menu-icon {*/
  /*    height: 100%;*/
  /*    background: {*/
  /*      image: url("./../../assets/imgs/icomenu.png");*/
  /*      position: center;*/
  /*      size: 100%;*/
  /*      repeat: no-repeat;*/
  /*    }*/

  /*    &:active {*/
  /*      background-image: url("./../../assets/imgs/icomenu_act.png");*/
  /*    }*/
  /*  }*/
  /*}*/
}
</style>



// WEBPACK FOOTER //
// src/components/Layout/Header.vue